import React from 'react'
import Page from '../Page'
import MasterHeader from '../../Components/MasterHeader/MasterHeader'
import Timeline from '../../Components/Timeline/Timeline'
import Modal from '../../Components/Modal/Modal'
import definition from './definition.json'


class Home extends Page {

    componentDidMount() {
        this.initialize();
    }

    render() {
        return (
            <div>
                <MasterHeader master={definition.master}></MasterHeader>
                <Timeline timeline={definition.timeline} showModal={this.props.onShowModal} />
                <Modal modal={this.props.modal} />
            </div>
        );
    }
}

export default Home;